import { biLogger } from '../biLogger';
import { locale, placement } from '../constants';
import { selectBiData } from '../selectors';
import { selectEngagementData } from '../selectors/selectEngagementData';
import { BiEventLogger } from '../types';
import { getKbWidgetState, getRuntimeDataForBi } from '../utils';

export const logWidgetScrolledToBottom: BiEventLogger = async (state) => {
  const biData = selectBiData(state);
  const engagementData = selectEngagementData(state);
  const { userPriorityClass, sessionId, chatbotView, contextBi } = await getRuntimeDataForBi(state);

  biLogger.widgetScrolledToBottom({
    max_scroll_at_first_position: engagementData.maxScrollAtFirstPosition,
    solution_info: undefined,
    article_id: biData.articleId,
    category_id: biData.categoryId,
    current_presented_state: biData.currentPresentedState,
    previous_presented_state: biData.previousPresentedState,
    ticket_id: biData.ticketId,
    session_id: sessionId ?? '',
    last_conversation_id: biData.conversationId,
    kb_widget_state: getKbWidgetState(state),
    lang: locale,
    lng: locale,
    placement,
    priority_class: userPriorityClass,
    chatbot_view: chatbotView,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_iframeurllist: contextBi?.context_iframeurllist,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    user_experience: contextBi?.user_experience,
    suggestion_id: undefined,
    widget_state: undefined,
    widget_view_mode: undefined,
  });
};
